<script>
  import { AppStore } from '../stores/AppStore'

  export let labels

  let previousIndex = undefined

  //Hacky but avoids having to create our own slider
  let index = $AppStore.state.durationIndex
  $: {
    if (previousIndex !== index) {
      previousIndex = index
      AppStore.setDurationToIndex(index)
    }
  }

</script>

<style>

  .trackHighlights {
    height: 8px;
    position: absolute;
    top:0;
    z-index: 5;
    width: 100%;
    pointer-events: none;
  }

  .trackHighlight {
    border-radius: 4px;
    z-index: 5;
  }

  input[type=range]{
    -webkit-appearance: none;
    background-color: #e2e8f0;
    height: 8px;
    border-radius: 4px;
    outline: none;
    /* z-index: -2; */
  }

  input[type='range']::-webkit-slider-runnable-track {
    z-index: 0;
  }

  input[type='range']::-webkit-slider-thumb {
      -webkit-appearance: none;
      width: 50px;
      height: 50px;
      background-color: #e2e8f0;
      z-index: 10;
      opacity: 0;
      cursor: pointer;
    }

  .middleLabel {
    flex: 1;
  }

  .startLabel, .endLabel {
    flex: 0.5;
  }

  .dot {
    width: 22px;
    height: 22px;
    border-radius: 22px;
    position: absolute;
    top: -7px;
    z-index: 5;
    pointer-events: none;
  }

</style>

<div class="w-full flex flex-col relative">
  <input class="w-full flex" type="range" min="0" max="{labels.length - 1}" steps="1" bind:value={index} >
  <div class="flex trackHighlights pl-1 pr-1">
    {#each labels as label, labelIndex}
      {#if labelIndex < labels.length - 1}
        <span class="flex-1 bg-gray-400 {index > labelIndex ? "bg-blue-500" : ""}" />
      {/if}
    {/each}
  </div>
  <ul class="flex justify-between select-none mt-2">
    {#each labels as label, labelIndex}
      {#if labelIndex === 0 }
        <li class="startLabel flex-justify-start">
          <div class="text-sm text-gray-500">{label}</div>
          <div 
            class="dot"
            class:bg-blue-300={index === labelIndex}
            class:bg-gray-300={labelIndex !== index}
            class:bg-blue-500={index >= labelIndex && index !== labelIndex}
          />
        </li>
      {:else if labelIndex === labels.length - 1}
        <li class="endLabel flex justify-end">
          <div class="endLabel text-sm text-gray-500 text-right">{label}</div>
          <div 
            class="dot"
            class:bg-blue-300={index === labelIndex}
            class:bg-gray-300={labelIndex !== index}
            class:bg-blue-500={labelIndex === index && index !== labelIndex}
          />
        </li>
      {:else} 
        <li class="middleLabel flex justify-center">
          <div class="w-full text-sm text-gray-500 text-center">{label}</div>
          <div 
            class="dot"
            class:bg-blue-300={index === labelIndex}
            class:bg-gray-300={labelIndex !== index}
            class:bg-blue-500={index >= labelIndex && index !== labelIndex}
          />
        </li>
      {/if}
    {/each}
  </ul>
</div>